import React, { useState } from 'react'
import { WidgetContent, TextField, Select } from '@duik/it'
import CreateNewModal from '../../UI/CreateNewModal'
import { ModalButton } from '../../UI/ModalButton'
import FormInputGroup from '../../UI/FormInputGroup'
import { Formik, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import 'react-datepicker/dist/react-datepicker.css'
import { Tabs, TabItem, Checkbox } from '@duik/it'
import moment from 'moment'
import {
  AddBackHaulBtn,
  HaulIdContainer,
  AssignBySMSButton,
  AddStartTimeButton,
  StyledDatePicker
} from '../styles'

const CreateOrEditDispatch = ({
  modalFunction,
  createOrEditDispatchModalToggle,
  projects,
  sites,
  hauls,
  drivers,
  createDispatch,
  dispatchDetail
}) => {
  const [step, setStep] = useState(0) //0, 1, 2, 3(SMS)
  const [selectedDrivers, setSelectedDrivers] = useState([])
  const [haulIdOptions, setHaulIdOptions] = useState(
    hauls.map((item, i) => {
      return { value: item._id, label: item.haulId }
    })
  )
  const [startTimeNum, setStartTimeNum] = useState([0])
  const [selectedStartTimeNum, setSelectedeStartTimeNum] = useState(0)
  const [startDateTimes, setStartDateTimes] = useState([])
  const [selectedTruckStart, setSelectedTruckStart] = useState(0)
  const defaultAddDriverSmsState = {
    phoneNumber: '',
    firstName: '',
    lastName: '',
    companyName: ''
  }
  const [addDriverSms, setAddDriverSms] = useState(defaultAddDriverSmsState)
  const [driversList, setDriversList] = useState(drivers)
  const [trucksNeeded, setTrucksNeeded] = useState(0)
  const [addBackHaul, setAddBackHaul] = useState(false)
  const [startSiteOptions, setStartSiteOptions] = useState([{ value: '', label: '' }])
  const [startTimeNotes, setStartTimeNotes] = useState([''])
  const [startSites, setStartSites] = useState([])
  const [driverSearchText, setDriverSearchText] = useState('')

  const projectOptions = projects.map((item, i) => {
    return { value: item._id, label: item.projectName }
  })

  const handleStartDateTimeChange = e => {
    const startDtString = e.toString()
    if (startTimeNum.length === 0) {
      setStartDateTimes([startDtString])
    } else {
      setStartDateTimes([
        ...startDateTimes.slice(0, selectedStartTimeNum),
        startDtString,
        ...startDateTimes.slice(selectedStartTimeNum + 1)
      ])
    }
  }

  const handleDriverFilter = values => {
    const truckTypes = values.truckType.map(item => item.value)
    const filteredDrivers = drivers.filter(driver => truckTypes.includes(driver.truckType))
    setDriversList(filteredDrivers)
  }

  const handleNotesChange = value => {
    const newNotes = startTimeNotes.slice(0)
    newNotes[selectedStartTimeNum] = value
    setStartTimeNotes(newNotes)
  }

  const handleDriverSearchTextChange = (e, values) => {
    setDriverSearchText(e.target.value)
    if (e.target.value === '') {
      handleDriverFilter(values)
      return
    }
    const lowerCaseSearchText = e.target.value.toLowerCase()
    const filteredDrivers = driversList.filter(
      driver =>
        driver.firstName.toLowerCase().includes(lowerCaseSearchText) ||
        driver.lastName.toLowerCase().includes(lowerCaseSearchText) ||
        driver.companyName.toLowerCase().includes(lowerCaseSearchText) ||
        driver.truckId.toLowerCase().includes(lowerCaseSearchText) ||
        driver.licencePlate.toLowerCase().includes(lowerCaseSearchText) ||
        driver.phoneNumber.includes(lowerCaseSearchText)
    )
    setDriversList(filteredDrivers)
  }

  const handleBackOrCancelClick = () => {
    if (step !== 0) {
      return setStep(step - 1)
    }
    if (step === 0) {
      return createOrEditDispatchModalToggle()
    }
    if (modalFunction === 'edit' && step === 0) {
      // haulDetailModalToggle(_id)
      createOrEditDispatchModalToggle()
    }
  }

  const handleNextButtonClick = (values, errors, setFieldError) => {
    const container = document.getElementById('dispatch-form')
    if (container) {
      container.scrollTo({ top: 0, behavior: 'smooth' })
    }
    if (step === 0) {
      if (
        !values.haulId.label ||
        values.truckType.length === 0 ||
        values.trailerType.length === 0 ||
        !values.trucksRequired
      ) {
        return setFieldError('haulId', 'Error')
      }
      handleStartSiteValues(values)
      handleDriverFilter(values)
      setStep(step + 1)
    }
    if (step === 1) {
      if (
        !values.startDateTime ||
        startSites.length === 0 ||
        !startSites[startSites.length - 1].siteName
      ) {
        return
      }
      setStep(step + 1)
    }
    if (step === 2) {
      if (selectedDrivers.length === 0) {
        return
      }
      addOrEditDispatch(values)
    }
    if (step === 3) {
      handleDriverSms()
    }
  }

  const addOrEditDispatch = values => {
    const payload = {
      ...values,
      startDateTime: values.startDateTime,
      startTimes: startDateTimes,
      project: projects.find(item => item._id === values.project.value),
      haul: hauls.find(item => item._id === values.haulId.value),
      haulId: values.haulId.label,
      backHaul: hauls.find(item => item._id === values.backHaulId.value) || '',
      backHaulId: values.backHaulId.label,
      pickUpSite: values.pickUpSite.value,
      dropOffSite: values.dropOffSite.value,
      backHaulPickUpSite: values.backHaulPickUpSite.value,
      backHaulDropOffSite: values.backHaulDropOffSite.value,
      startSite: startSites,
      trailerType: values.trailerType.map(item => item.value),
      truckType: values.truckType.map(item => item.value),
      drivers: selectedDrivers,
      notes: startTimeNotes
    }

    createDispatch(payload)

    // if (modalFunction === 'edit') {
    // return editHaul(haulValues)
    // }
  }

  const handleHaulIdChange = (e, setFieldValue, values) => {
    const haul = hauls.find(item => item._id === e.value)
    const project = projects.find(item => haul.project._id === item._id)
    setFieldValue('project', { value: project._id, label: project.projectName }, false)
    setFieldValue('haulId', e, false)

    setFieldValue('pickUpSite', { value: haul.pickUpSite, label: haul.pickUpSite.siteName }, false)
    setFieldValue(
      'dropOffSite',
      { value: haul.dropOffSite, label: haul.dropOffSite.siteName },
      false
    )
    setFieldValue('material', haul.material || '')
  }

  const handleBackHaulIdChange = (e, setFieldValue, values) => {
    const haul = hauls.find(item => item._id === e.value)

    if (haul.haulId === values.haulId.label) {
      return
    }
    setFieldValue('backHaulId', e, false)

    setFieldValue(
      'backHaulPickUpSite',
      { value: haul.pickUpSite, label: haul.pickUpSite.siteName },
      false
    )
    setFieldValue(
      'backHaulDropOffSite',
      { value: haul.dropOffSite, label: haul.dropOffSite.siteName },
      false
    )
    setFieldValue('backHaulMaterial', haul.material || '')
  }

  const handleStartSiteValues = values => {
    let startSites = [
      { value: values.pickUpSite.value, label: values.pickUpSite.label },
      { value: values.dropOffSite.value, label: values.dropOffSite.label }
    ]

    if (values.backHaulPickUpSite.label !== '') {
      startSites = [
        ...startSites,
        {
          value: values.backHaulPickUpSite.value,
          label: values.backHaulPickUpSite.label
        },
        {
          value: values.backHaulDropOffSite.value,
          label: values.backHaulDropOffSite.label
        }
      ]
    }

    setStartSiteOptions(startSites)
  }

  const handleProjectChange = (e, setFieldValue) => {
    setFieldValue('project', e, false)
    setHaulIdOptions(
      hauls
        .filter(item => item.projectId === e.value)
        .map(item => {
          return { value: item._id, label: item.haulId }
        })
    )
    setFieldValue(
      'haulId',
      {
        value: '',
        label: ''
      },
      false
    )
    setFieldValue(
      'backHaulId',
      {
        value: '',
        label: ''
      },
      false
    )
  }

  const handleDriverSelect = e => {
    const driver = e
    driver.startDateTime = startDateTimes[selectedTruckStart]
    driver.notes = startTimeNotes[selectedTruckStart]
    driver.startSite = startSites[selectedTruckStart].siteName
    const isSelectedIndex = selectedDrivers.findIndex(item => item._id === e._id)
    if (isSelectedIndex > -1) {
      selectedDrivers.splice(isSelectedIndex, 1)
      setSelectedDrivers([...selectedDrivers])
    } else {
      setSelectedDrivers([...selectedDrivers, driver])
    }
  }

  const handleTrucksRequired = (e, setFieldValue) => {
    setTrucksNeeded(Number(e.target.value))
    setFieldValue('trucksRequired', e.target.value)
  }

  const handleStartSiteChange = (e, setFieldValue) => {
    const newSites = startSites.slice(0)
    newSites[selectedStartTimeNum] = e.value
    setStartSites(newSites)
    setFieldValue('startSite', e.value)
  }

  const handleDriverSms = () => {
    const driverExists = drivers.find(item => item.phoneNumber === addDriverSms.phoneNumber)
    if (driverExists) {
      handleDriverSelect(driverExists)
    } else {
      const newDriver = {
        ...addDriverSms,
        startDateTime: startDateTimes[selectedTruckStart],
        notes: startTimeNotes[selectedTruckStart],
        startSite: startSites[selectedTruckStart].siteName,
        inviteBySms: true
      }
      setDriversList([...drivers, newDriver])
      setSelectedDrivers([...selectedDrivers, newDriver])
    }
    setAddDriverSms(defaultAddDriverSmsState)
    setStep(2)
  }

  const getBannerText = () => {
    switch (step) {
      case 0:
        return 'Details'
      case 1:
        return 'Schedule'
      case 2:
        return `${selectedDrivers.length}/${trucksNeeded} Trucks Assigned`
      case 3:
        return 'Enter a phone number to assign a new truck'
      default:
        break
    }
  }

  const getModalTitle = () => {
    if (step === 3) {
      return 'Assign by SMS'
    }
    if (modalFunction === 'edit') {
      return 'Edit Dispatch'
    }
    if (modalFunction === 'new') {
      return 'New Dispatch'
    }
  }

  const isNewMode = modalFunction === 'new'

  return (
    <CreateNewModal
      title={getModalTitle()}
      handleCloseModal={createOrEditDispatchModalToggle}
      bannerText={getBannerText()}
      bannerTextRight={step !== 3 ? `Step ${step + 1} of 3` : ''}
    >
      <Formik
        enableReinitialize={false}
        initialValues={{
          haulId: isNewMode
            ? { value: '', label: '' }
            : { value: dispatchDetail.haul, label: dispatchDetail.haul.haulId },
          pickUpSite: isNewMode
            ? { value: '', label: '' }
            : { value: dispatchDetail.pickUpSite, label: dispatchDetail.pickUpSite.siteName },
          dropOffSite: isNewMode
            ? { value: '', label: '' }
            : { value: dispatchDetail.dropOffSite, label: dispatchDetail.dropOffSite.siteName },
          backHaulId:
            isNewMode || !dispatchDetail.backHaulId
              ? { value: '', label: '' }
              : { value: dispatchDetail.backHaulId, label: dispatchDetail.backHaulId.haulId },
          backHaulPickUpSite:
            isNewMode || dispatchDetail.backHaulPickUpSite
              ? { value: '', label: '' }
              : {
                  value: dispatchDetail.backHaulPickUpSite,
                  label: dispatchDetail.backHaulPickUpSite.siteName
                },
          backHaulDropOffSite:
            isNewMode || dispatchDetail.backHaulDropOffSite
              ? { value: '', label: '' }
              : {
                  value: dispatchDetail.backHaulDropOffSite,
                  label: dispatchDetail.backHaulDropOffSite.siteName
                },
          startSite:
            isNewMode || dispatchDetail.startSite
              ? { value: '', label: '' }
              : {
                  value: dispatchDetail.startSite,
                  label: dispatchDetail.startSite.siteName
                },
          notes: isNewMode ? '' : dispatchDetail.notes,
          material: isNewMode ? '' : dispatchDetail.material,
          backHaulMaterial: isNewMode ? '' : dispatchDetail.backHaulMaterial,
          project: isNewMode
            ? { value: '', label: '' }
            : { value: dispatchDetail.project, label: dispatchDetail.project.projectName },
          startDateTime: isNewMode ? '' : dispatchDetail.startDateTime,
          // startTimes: isNewMode ? [''] : dispatchDetail.startTimes,
          truckType: isNewMode ? [] : dispatchDetail.truckType,
          trailerType: isNewMode ? [] : dispatchDetail.trailerType,
          trucksRequired: isNewMode ? '' : dispatchDetail.trucksRequired || ''
        }}
        validationSchema={DispatchSchema}
        handleSubmit={e => console.log(e)}
        onSubmit={values => {
          addOrEditDispatch(values)
        }}
        render={({
          values,
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          submitForm,
          isSubmitting,
          setFieldValue,
          setFieldTouched,
          touched,
          setFieldError
        }) => (
          <form>
            <WidgetContent
              style={{
                height: '355px',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                padding: 0,
                overflowY: 'scroll',
                overflowX: 'hidden'
              }}
              id="dispatch-form"
            >
              {step === 0 && (
                <div style={{ padding: '0 30px' }}>
                  <div style={{ paddingTop: '20px' }}>
                    <FormInputGroup direction={addBackHaul && 'horizontal'}>
                      <>
                        {isNewMode ? (
                          <HaulIdContainer fullWidth={!addBackHaul}>
                            <Select
                              name="haulId"
                              className="optionsFullWidth"
                              label={
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                  }}
                                >
                                  <p
                                    style={{
                                      fontWeight: 500,
                                      fontSize: '0.75rem',
                                      color: '#9ea0a5',
                                      lineHeight: '1.125rem'
                                    }}
                                  >
                                    Haul ID
                                  </p>
                                  {!addBackHaul && (
                                    <AddBackHaulBtn onClick={() => setAddBackHaul(true)}>
                                      + Add Backhaul
                                    </AddBackHaulBtn>
                                  )}
                                </div>
                              }
                              activeOption={{
                                value: values.haulId.value,
                                label: values.haulId.label
                              }}
                              options={haulIdOptions}
                              onOptionClick={e => handleHaulIdChange(e, setFieldValue, values)}
                              menuPosition="bottom-left"
                            />
                            <ErrorMessage
                              name="haulId"
                              render={msg => (
                                <span
                                  style={{
                                    position: 'relative',
                                    color: '#E6492D',
                                    fontSize: '0.75rem'
                                  }}
                                >
                                  {msg.value}
                                </span>
                              )}
                            />
                          </HaulIdContainer>
                        ) : (
                          <TextField
                            className="fullWidthInputBox"
                            label="Haul ID"
                            name="haulId"
                            value={dispatchDetail.haul.haulId}
                            disabled
                          />
                        )}
                        {addBackHaul && (
                          <HaulIdContainer fullWidth={!addBackHaul}>
                            <Select
                              name="backHaulId"
                              label="Back Haul ID"
                              className="optionsFullWidth"
                              activeOption={{
                                value: values.backHaulId.value,
                                label: values.backHaulId.label
                              }}
                              options={haulIdOptions}
                              menuPosition="bottom-left"
                              onOptionClick={e => handleBackHaulIdChange(e, setFieldValue, values)}
                            />
                            <ErrorMessage
                              name="backHaulId"
                              render={msg => (
                                <span
                                  style={{
                                    position: 'relative',
                                    color: '#E6492D',
                                    fontSize: '0.75rem'
                                  }}
                                >
                                  {msg.value}
                                </span>
                              )}
                            />
                          </HaulIdContainer>
                        )}
                      </>
                    </FormInputGroup>
                    <div style={{ marginTop: '10px' }}>
                      <FormInputGroup>
                        {isNewMode ? (
                          <>
                            <Select
                              className="fullWidthSelectBox optionsFullWidth"
                              name="project"
                              label="Project"
                              activeOption={{
                                value: values.project.value,
                                label: values.project.label
                              }}
                              options={projectOptions}
                              menuPosition="bottom-left"
                              onOptionClick={e => handleProjectChange(e, setFieldValue)}
                            />
                            <ErrorMessage
                              name="project"
                              render={msg => (
                                <span
                                  style={{
                                    position: 'relative',
                                    color: '#E6492D',
                                    fontSize: '0.75rem'
                                  }}
                                >
                                  {msg.value}
                                </span>
                              )}
                            />
                          </>
                        ) : (
                          <TextField
                            className="fullWidthInputBox"
                            label="Project"
                            name="project"
                            value={dispatchDetail.project.projectName}
                            disabled
                          />
                        )}
                      </FormInputGroup>
                    </div>

                    <div style={{ display: 'none' }}>
                      <FormInputGroup>
                        <div style={{ paddingTop: '30px' }}>
                          <FormInputGroup>
                            <TextField
                              className="fullWidthInputBox"
                              label="Material"
                              name="material"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.material}
                              disabled
                            />
                            <ErrorMessage
                              name="material"
                              render={msg => (
                                <span
                                  style={{
                                    color: '#E6492D',
                                    fontSize: '0.75rem'
                                  }}
                                >
                                  {msg}
                                </span>
                              )}
                            />
                          </FormInputGroup>
                        </div>
                      </FormInputGroup>
                    </div>

                    <div style={{ paddingTop: '30px' }}>
                      <FormInputGroup direction="horizontal">
                        <div style={{ width: '150px' }}>
                          <TextField
                            label="Trucks Requested"
                            name="trucksRequired"
                            onChange={e => handleTrucksRequired(e, setFieldValue)}
                            onBlur={handleBlur}
                            value={values.trucksRequired}
                            type="number"
                            disabled={!isNewMode}
                          />
                          <ErrorMessage
                            name="trucksRequired"
                            render={msg => (
                              <span
                                style={{
                                  color: '#E6492D',
                                  fontSize: '0.75rem'
                                }}
                              >
                                {msg}
                              </span>
                            )}
                          />
                        </div>
                        <div style={{ width: '314px' }}>
                          <Select
                            activeOption={values.truckType}
                            options={['Single', 'Tandem', 'Tri-axle', 'End Dump'].map(item => {
                              return { value: item, label: item }
                            })}
                            name="truckType"
                            label="Truck Type"
                            className="optionsFullWidth"
                            menuPosition="bottom-left"
                            onBlur={() => setFieldTouched('truckType')}
                            onOptionClick={e => {
                              if (
                                values.truckType &&
                                values.truckType.find(item => item.value === e.value)
                              ) {
                                setFieldValue(
                                  'truckType',
                                  values.truckType.filter(item => item.value !== e.value)
                                )
                              } else {
                                setFieldValue('truckType', [...values.truckType, e])
                              }
                            }}
                            multiple
                          />
                          <ErrorMessage
                            name="truckType"
                            render={msg => (
                              <span
                                style={{
                                  position: 'relative',
                                  color: '#E6492D',
                                  fontSize: '0.75rem'
                                }}
                              >
                                {msg.value}
                              </span>
                            )}
                          />
                        </div>
                      </FormInputGroup>
                    </div>

                    <FormInputGroup>
                      <div style={{ paddingTop: '10px' }}>
                        <Select
                          className="fullWidthSelectBox optionsFullWidth"
                          activeOption={values.trailerType}
                          options={[
                            'None',
                            'Tandem Pony',
                            'Tri pony',
                            '3 Axle Transfer',
                            '4 Axle Transfer',
                            'Quad trailer'
                          ].map(item => {
                            return { value: item, label: item }
                          })}
                          name="trailerType"
                          label="Trailer Type"
                          menuPosition="bottom-left"
                          onBlur={() => setFieldTouched('trailerType')}
                          onOptionClick={e => {
                            if (
                              values.trailerType &&
                              values.trailerType.find(item => item.value === e.value)
                            ) {
                              setFieldValue(
                                'trailerType',
                                values.trailerType.filter(item => item.value !== e.value)
                              )
                            } else {
                              setFieldValue('trailerType', [...values.trailerType, e])
                            }
                          }}
                          multiple
                        />
                        <ErrorMessage
                          name="trailerType"
                          render={msg => (
                            <span
                              style={{
                                position: 'relative',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg.value}
                            </span>
                          )}
                        />
                      </div>
                    </FormInputGroup>
                  </div>
                </div>
              )}

              {step === 1 && (
                <div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}
                  >
                    <Tabs sm>
                      {startTimeNum.map((item, i) => (
                        <TabItem
                          className={selectedStartTimeNum === item ? 'active' : undefined}
                          onClick={() => setSelectedeStartTimeNum(item)}
                          key={i}
                        >
                          Start {item + 1}
                        </TabItem>
                      ))}
                    </Tabs>
                    <div>
                      <AddStartTimeButton
                        style={{ paddingRight: '30px', color: '#289C91', fontSize: '14px' }}
                        onClick={() => {
                          if (startDateTimes.length === startTimeNum[startTimeNum.length - 1] + 1) {
                            setStartTimeNum([
                              ...startTimeNum,
                              startTimeNum[startTimeNum.length - 1] + 1
                            ])
                            setSelectedeStartTimeNum(startTimeNum[startTimeNum.length - 1] + 1)
                            setStartTimeNotes([...startTimeNotes, ''])
                            setStartSites([...startSites, ''])
                          }
                        }}
                      >
                        + Add Start Time
                      </AddStartTimeButton>
                    </div>
                  </div>
                  <div style={{ paddingTop: '20px' }}>
                    <div style={{ padding: '0 30px' }}>
                      <FormInputGroup>
                        <div style={{ marginBottom: '0.5rem' }}>
                          <span className="content-title">DATE & TIME</span>
                        </div>
                        <StyledDatePicker
                          selectsStart
                          className="uik-input__input fullWidthInputBox"
                          name="Date & Time"
                          // selected={values.startDateTime}
                          style={{ border: '1px solid #eaedf3' }}
                          selected={
                            startDateTimes[selectedStartTimeNum]
                              ? new Date(startDateTimes[selectedStartTimeNum])
                              : ''
                          }
                          onChange={e => {
                            setFieldValue('startDateTime', e)
                            handleStartDateTimeChange(e)
                          }}
                          showTimeSelect
                          timeFormat="HH:mm"
                          timeIntervals={15}
                          dateFormat="MMMM d, yyyy HH:mm"
                          timeCaption="Time"
                          onBlur={handleBlur}
                          autoComplete="off"
                          minTime={moment()
                            .add(15, 'minutes')
                            .toDate()}
                          maxTime={moment()
                            .add(1, 'years')
                            .toDate()}
                        />
                        <ErrorMessage
                          name="poNumber"
                          render={msg => (
                            <span
                              style={{
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg}
                            </span>
                          )}
                        />
                      </FormInputGroup>

                      <FormInputGroup>
                        <div style={{ paddingTop: '30px' }}>
                          <Select
                            name="startSite"
                            label="Start Location"
                            className="optionsFullWidth"
                            activeOption={{
                              value: startSites[selectedStartTimeNum],
                              label: startSites[selectedStartTimeNum]
                                ? startSites[selectedStartTimeNum].siteName
                                : ''
                            }}
                            options={startSiteOptions}
                            menuPosition="bottom-left"
                            onOptionClick={e => {
                              handleStartSiteChange(e, setFieldValue)
                            }}
                          />
                          <ErrorMessage
                            name="startSite"
                            render={msg => (
                              <span
                                style={{
                                  position: 'relative',
                                  color: '#E6492D',
                                  fontSize: '0.75rem'
                                }}
                              >
                                {msg.value}
                              </span>
                            )}
                          />
                        </div>
                      </FormInputGroup>

                      <div style={{ paddingTop: '30px' }}>
                        <div style={{ marginBottom: '0.5rem' }}>
                          <span className="content-title">DRIVER INSTRUCTIONS (OPTIONAL)</span>
                        </div>
                        <textarea
                          className="fullWidthInputBox uik-input__input"
                          label="Notes"
                          name="notes"
                          style={{
                            height: '118px',
                            resize: 'none',
                            padding: '16px',
                            border: '1px solid #eaedf3'
                          }}
                          value={startTimeNotes[selectedStartTimeNum]}
                          onChange={e => handleNotesChange(e.target.value)}
                          onBlur={handleBlur}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {step === 2 && (
                <div style={{ width: '100%' }}>
                  <Tabs sm>
                    {startDateTimes.map((item, i) => (
                      <TabItem
                        className={selectedTruckStart === i ? 'active' : undefined}
                        onClick={() => setSelectedTruckStart(i)}
                        key={i}
                      >
                        {moment(new Date(item)).format('HH:mm')}
                      </TabItem>
                    ))}
                  </Tabs>
                  <div style={{ padding: '0 30px' }}>
                    <div
                      style={{
                        marginTop: '16px',
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <span style={{ fontSize: '12px', color: '#9EA0A5' }}>
                        ASSIGNED ({selectedDrivers.length}) -{' '}
                        {values.pickUpSite.label
                          ? `${values.pickUpSite.label} to ${values.dropOffSite.label}`
                          : ''}
                      </span>
                      <AssignBySMSButton
                        style={{ fontSize: '14px', color: '#289C91' }}
                        onClick={() => setStep(3)}
                      >
                        + Assign by SMS
                      </AssignBySMSButton>
                    </div>
                    <div
                      style={{
                        marginTop: '8px',
                        height: '200px',
                        overflowY: 'scroll',
                        border: '1px solid #D8DCE6',
                        borderRadius: '4px'
                      }}
                    >
                      <table style={{ width: '100%', padding: '10px 16px' }}>
                        <tbody>
                          {selectedDrivers
                            .filter(
                              item => item.startDateTime === startDateTimes[selectedTruckStart]
                            )
                            .map((item, i) => (
                              <tr style={{ height: '40px' }} key={i}>
                                <td>
                                  <span>
                                    {item.firstName ? item.firstName : item.phoneNumber}{' '}
                                    {item.lastName && item.lastName}
                                  </span>
                                </td>
                                <td>
                                  <span>{item.truckType && item.truckType}</span>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>

                    <div
                      style={{
                        paddingTop: '16px',
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <div style={{ width: '322px' }}>
                        <TextField
                          className="threeQuarterWidthInputBox materials optionsFullWidth"
                          label=""
                          name="driverSearch"
                          onChange={e => handleDriverSearchTextChange(e, values)}
                          onBlur={handleBlur}
                          value={driverSearchText}
                          placeholder="Search for a driver"
                        />
                        <ErrorMessage
                          name="driverSearch"
                          render={msg => (
                            <span
                              style={{
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg}
                            </span>
                          )}
                        />
                      </div>
                      <div style={{ width: '134px' }}>
                        <Select
                          style={{ width: '134px' }}
                          activeOption={[{ value: '', label: '' }]}
                          label=""
                          options={[{ value: 'All', label: 'All' }]}
                          name="driverFilter"
                          menuPosition="bottom-left"
                          onOptionClick={e => console.log(e)}
                          placeholder="All"
                        />
                        <ErrorMessage
                          name="driverFilter"
                          render={msg => (
                            <span
                              style={{
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg.value}
                            </span>
                          )}
                        />
                      </div>
                    </div>

                    <div
                      style={{
                        marginTop: '16px',
                        height: '200px',
                        overflowY: 'scroll',
                        border: '1px solid #D8DCE6',
                        borderRadius: '4px'
                      }}
                    >
                      <table style={{ width: '100%', padding: '10px 16px' }}>
                        <tbody>
                          {driversList.map((item, i) => (
                            <tr style={{ height: '40px' }} key={i}>
                              <td>
                                <Checkbox
                                  onChange={() => handleDriverSelect(item)}
                                  style={{ color: '#34AA44' }}
                                  checked={selectedDrivers.find(
                                    driver => driver.phoneNumber === item.phoneNumber
                                  )}
                                />
                              </td>
                              <td>
                                <span>
                                  {item.firstName ? item.firstName : item.phoneNumber}{' '}
                                  {item.lastName && item.lastName}
                                </span>
                              </td>
                              <td>
                                <span>{item.truckType && item.truckType}</span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              {step === 3 && (
                <div style={{ padding: '0 30px' }}>
                  <div style={{ paddingTop: '20px' }}>
                    <FormInputGroup>
                      <FormInputGroup>
                        <TextField
                          className="fullWidthInputBox"
                          label="Phone number"
                          name="phoneNumber"
                          onChange={e => {
                            setAddDriverSms({ ...addDriverSms, phoneNumber: e.target.value })
                          }}
                          onBlur={handleBlur}
                          value={addDriverSms.phoneNumber}
                          maxLength={10}
                          minLength={10}
                        />
                        <ErrorMessage
                          name="phoneNumber"
                          render={msg => (
                            <span
                              style={{
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg}
                            </span>
                          )}
                        />
                      </FormInputGroup>
                    </FormInputGroup>
                  </div>
                  <div style={{ paddingTop: '20px' }}>
                    <FormInputGroup>
                      <FormInputGroup>
                        <TextField
                          className="fullWidthInputBox"
                          label="First name"
                          name="firstName"
                          onChange={e => {
                            setAddDriverSms({ ...addDriverSms, firstName: e.target.value })
                          }}
                          onBlur={handleBlur}
                          value={addDriverSms.firstName}
                        />
                        <ErrorMessage
                          name="firstName"
                          render={msg => (
                            <span
                              style={{
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg}
                            </span>
                          )}
                        />
                      </FormInputGroup>
                    </FormInputGroup>
                  </div>
                  <div style={{ paddingTop: '20px' }}>
                    <FormInputGroup>
                      <FormInputGroup>
                        <TextField
                          className="fullWidthInputBox"
                          label="Last name"
                          name="lastName"
                          onChange={e => {
                            setAddDriverSms({ ...addDriverSms, lastName: e.target.value })
                          }}
                          onBlur={handleBlur}
                          value={addDriverSms.lastName}
                        />
                        <ErrorMessage
                          name="lastName"
                          render={msg => (
                            <span
                              style={{
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg}
                            </span>
                          )}
                        />
                      </FormInputGroup>
                    </FormInputGroup>
                  </div>
                  {/* <div style={{ paddingTop: '20px' }}>
                    <FormInputGroup>
                      <FormInputGroup>
                        <TextField
                          className="fullWidthInputBox"
                          label="Company"
                          name="company"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={addDriverSms.companyName}
                          disabled
                        />
                        <ErrorMessage
                          name="company"
                          render={msg => (
                            <span
                              style={{
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg}
                            </span>
                          )}
                        />
                      </FormInputGroup>
                    </FormInputGroup>
                  </div> */}
                </div>
              )}
            </WidgetContent>
            <div style={{ display: 'flex' }}>
              <WidgetContent
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  border: 'none',
                  width: '482px'
                }}
              >
                <div style={{ width: '83px' }}>
                  <ModalButton
                    buttonStyle="tertiary"
                    name={step === 0 ? 'Cancel' : 'Back'}
                    onClick={handleBackOrCancelClick}
                  />
                </div>
                <div style={{ width: '83px' }}>
                  <ModalButton
                    success
                    disabled={isSubmitting}
                    name={step !== 2 ? (step === 3 ? 'Ok' : 'Next') : 'Save'}
                    onClick={() => handleNextButtonClick(values, errors, setFieldError)}
                  />
                </div>
              </WidgetContent>
            </div>
          </form>
        )}
      />
    </CreateNewModal>
  )
}

export default CreateOrEditDispatch

const DispatchSchema = Yup.object().shape({
  haulId: Yup.object().shape({
    value: Yup.string()
      .trim()
      .required('Required')
  }),
  project: Yup.object().shape({
    value: Yup.string()
      .trim()
      .required('Required')
  }),
  pickUpSite: Yup.object().shape({
    value: Yup.string()
      .trim()
      .required('Required')
  }),
  dropOffSite: Yup.object().shape({
    value: Yup.string()
      .trim()
      .required('Required')
  }),
  startDateTime: Yup.string(),
  materials: Yup.string().required,
  truckType: Yup.string().required('Required'),
  trailerType: Yup.string().required('Required'),
  trucksRequired: Yup.number().required('Required')
  // phoneNumber: Yup.string()
  //   .length(10, 'Phone number must be 10 digits')
  //   .matches(/^[0-9]{0,}$/, 'No spaces or special characters allowed')
})
